import React, { useState } from 'react';
import { TabsWrapper } from 'framework/ui/TabsWrapper';
import { ShowPageLayout } from 'framework/ui/layout';
import AboutMeFeedbackPreview from '../shared/AboutMeFeedbackPreview';
import GivenFeedbackPreview from '../shared/GivenFeedbackPreview';
import AccordionSection from '../../shared/AccrodionSection';

const FeedbackSection: React.FC = React.memo(() => {
  const [activeTab, setActiveTab] = useState(0);

  const renderAboutMeContent = () => {
    return <AboutMeFeedbackPreview />;
  };

  const renderGivenContent = () => {
    return <GivenFeedbackPreview />;
  };

  const tabs = [
    {
      label: 'About me',
      content: renderAboutMeContent(),
      value: 0,
    },
    {
      label: 'Given',
      content: renderGivenContent(),
      value: 1,
    },
  ];

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  return (
    <ShowPageLayout minHeight="100px">
      <AccordionSection title="My feedback" sxDetails={{ pt: 0 }}>
        <TabsWrapper
          tabs={tabs}
          defaultTab={activeTab}
          changeTabCallback={handleTabChange}
          isShowContent
          sxContentProps={{ p: 0 }}
        />
      </AccordionSection>
    </ShowPageLayout>
  );
});

export default FeedbackSection;
